var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle3, _rect, _rect2, _rect3, _rect4, _circle4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _circle5, _path21, _path22, _path23, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeExpiredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 151,
    viewBox: "0 0 150 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.676 28.1777C38.676 26.1464 40.314 24.5 42.3345 24.5H96.6899C98.7104 24.5 100.348 26.1464 100.348 28.1777C100.348 30.2089 98.7104 31.8553 96.6899 31.8553H85.1916C83.1711 31.8553 81.5331 33.5018 81.5331 35.533C81.5331 37.5642 83.1711 39.2107 85.1916 39.2107H111.847C114.445 39.2107 116.551 41.3276 116.551 43.9391C116.551 46.5506 114.445 48.6675 111.847 48.6675H29.7909C27.1931 48.6675 25.0871 46.5506 25.0871 43.9391C25.0871 41.3276 27.1931 39.2107 29.7909 39.2107H52.2648C51.8045 39.2107 51.364 39.1252 50.9582 38.9693C52.3335 38.4405 53.3101 37.1014 53.3101 35.533C53.3101 33.9645 52.3335 32.6254 50.9582 32.0967C51.364 31.9408 51.8045 31.8553 52.2648 31.8553H42.3345C40.314 31.8553 38.676 30.2089 38.676 28.1777Z",
    fill: "#F6F8FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.641 43.9391C118.641 41.3276 120.747 39.2107 123.345 39.2107H132.753C135.35 39.2107 137.456 41.3276 137.456 43.9391C137.456 46.5506 135.35 48.6675 132.753 48.6675H123.345C120.747 48.6675 118.641 46.5506 118.641 43.9391Z",
    fill: "#F6F8FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7909 56.0228C27.1931 56.0228 25.0871 58.1398 25.0871 60.7513C25.0871 63.3628 27.1931 65.4797 29.7909 65.4797H94.0767C96.6745 65.4797 98.7805 63.3628 98.7805 60.7513C98.7805 58.1398 96.6745 56.0228 94.0767 56.0228H29.7909Z",
    fill: "#F6F8FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22648 76.7754C5.22648 74.5992 6.98145 72.835 9.14634 72.835H41.0279C43.1928 72.835 44.9477 74.5992 44.9477 76.7754C44.9477 78.9516 43.1928 80.7157 41.0279 80.7157H39.4599C37.295 80.7157 35.5401 82.4799 35.5401 84.6561C35.5401 86.8323 37.295 88.5965 39.4599 88.5965H64.547C62.3822 88.5965 60.6272 86.8323 60.6272 84.6561C60.6272 82.4799 62.3822 80.7157 64.547 80.7157H123.606C125.771 80.7157 127.526 82.4799 127.526 84.6561C127.526 86.8323 125.771 88.5965 123.606 88.5965H112.892C110.727 88.5965 108.972 90.3606 108.972 92.5368C108.972 94.713 110.727 96.4772 112.892 96.4772H118.902C121.067 96.4772 122.822 98.2413 122.822 100.418C122.822 102.594 121.067 104.358 118.902 104.358H94.8606C97.0255 104.358 98.7805 106.122 98.7805 108.298C98.7805 110.474 97.0255 112.239 94.8606 112.239H64.0244C61.8595 112.239 60.1045 114.003 60.1045 116.179C60.1045 118.355 61.8595 120.119 64.0244 120.119H68.7282C70.8931 120.119 72.6481 121.883 72.6481 124.06C72.6481 126.236 70.8931 128 68.7282 128H36.324C34.1592 128 32.4042 126.236 32.4042 124.06C32.4042 121.883 34.1592 120.119 36.324 120.119H36.8467C39.0116 120.119 40.7666 118.355 40.7666 116.179C40.7666 114.003 39.0116 112.239 36.8467 112.239H3.91986C1.75497 112.239 0 110.474 0 108.298C0 106.122 1.75497 104.358 3.91986 104.358H19.5993C17.4344 104.358 15.6794 102.594 15.6794 100.418C15.6794 98.2413 17.4344 96.4772 19.5993 96.4772H20.3833C22.5482 96.4772 24.3031 94.713 24.3031 92.5368C24.3031 90.3606 22.5482 88.5965 20.3833 88.5965H18.554C16.3891 88.5965 14.6341 86.8323 14.6341 84.6561C14.6341 82.4799 16.3891 80.7157 18.554 80.7157H9.14634C6.98145 80.7157 5.22648 78.9516 5.22648 76.7754Z",
    fill: "#F6F8FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.15 80.7157C133.985 80.7157 132.23 82.4799 132.23 84.6561C132.23 86.8323 133.985 88.5965 136.15 88.5965H146.08C148.245 88.5965 150 86.8323 150 84.6561C150 82.4799 148.245 80.7157 146.08 80.7157H136.15Z",
    fill: "#F6F8FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5087 113.815C90.7768 113.815 89.3728 115.226 89.3728 116.967C89.3728 118.708 90.7768 120.119 92.5087 120.119H99.3031C101.035 120.119 102.439 118.708 102.439 116.967C102.439 115.226 101.035 113.815 99.3031 113.815H92.5087Z",
    fill: "#F6F8FC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0408,
    cy: 65.5408,
    r: 2.04082,
    fill: "#EEF2F5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.734,
    cy: 109.944,
    r: 2.04082,
    fill: "#EEF2F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.618 103.882C139.618 103.533 139.901 103.25 140.25 103.25C140.599 103.25 140.882 103.533 140.882 103.882V107.671C140.882 108.02 140.599 108.303 140.25 108.303C139.901 108.303 139.618 108.02 139.618 107.671V103.882Z",
    fill: "#D2D9E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.618 110.829C139.618 110.48 139.901 110.197 140.25 110.197C140.599 110.197 140.882 110.48 140.882 110.829V114.618C140.882 114.967 140.599 115.25 140.25 115.25C139.901 115.25 139.618 114.967 139.618 114.618V110.829Z",
    fill: "#D2D9E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M145.618 108.618C145.967 108.618 146.25 108.901 146.25 109.25C146.25 109.599 145.967 109.882 145.618 109.882H141.829C141.48 109.882 141.197 109.599 141.197 109.25C141.197 108.901 141.48 108.618 141.829 108.618H145.618Z",
    fill: "#D2D9E7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.671 108.618C139.02 108.618 139.303 108.901 139.303 109.25C139.303 109.599 139.02 109.882 138.671 109.882H134.882C134.533 109.882 134.25 109.599 134.25 109.25C134.25 108.901 134.533 108.618 134.882 108.618H138.671Z",
    fill: "#D2D9E7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5944 125.911C25.9089 125.597 26.419 125.597 26.7336 125.911C27.0482 126.226 27.0481 126.736 26.7336 127.051L23.3159 130.468C23.0013 130.783 22.4913 130.783 22.1767 130.468C21.8621 130.154 21.8621 129.644 22.1767 129.329L25.5944 125.911Z",
    fill: "#D2D9E7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3286 132.177C19.6432 131.862 20.1532 131.862 20.4678 132.177C20.7824 132.492 20.7824 133.002 20.4678 133.316L17.0502 136.734C16.7356 137.049 16.2256 137.049 15.911 136.734C15.5963 136.419 15.5964 135.909 15.9109 135.595L19.3286 132.177Z",
    fill: "#D2D9E7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7336 135.595C27.0482 135.909 27.0481 136.419 26.7336 136.734C26.419 137.049 25.909 137.049 25.5944 136.734L22.1767 133.316C21.8621 133.002 21.8621 132.492 22.1767 132.177C22.4912 131.862 23.0013 131.862 23.3159 132.177L26.7336 135.595Z",
    fill: "#D2D9E7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4678 129.329C20.7824 129.644 20.7824 130.154 20.4678 130.468C20.1533 130.783 19.6432 130.783 19.3286 130.468L15.911 127.051C15.5963 126.736 15.5964 126.226 15.911 125.911C16.2255 125.597 16.7356 125.597 17.0502 125.911L20.4678 129.329Z",
    fill: "#D2D9E7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2105 27.4605C23.6465 27.4605 24 27.814 24 28.25C24 28.686 23.6465 29.0395 23.2105 29.0395L18.4737 29.0395C18.0377 29.0395 17.6842 28.686 17.6842 28.25C17.6842 27.814 18.0377 27.4605 18.4737 27.4605L23.2105 27.4605Z",
    fill: "#D2D9E7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5263 27.4605C14.9623 27.4605 15.3158 27.814 15.3158 28.25C15.3158 28.686 14.9623 29.0395 14.5263 29.0395L9.78947 29.0395C9.35349 29.0395 9 28.686 9 28.25C9 27.814 9.35349 27.4605 9.78947 27.4605L14.5263 27.4605Z",
    fill: "#D2D9E7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2895 34.9605C17.2895 35.3966 16.936 35.75 16.5 35.75C16.064 35.75 15.7105 35.3966 15.7105 34.9605L15.7105 30.2237C15.7105 29.7877 16.064 29.4342 16.5 29.4342C16.936 29.4342 17.2895 29.7877 17.2895 30.2237L17.2895 34.9605Z",
    fill: "#D2D9E7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2895 26.2763C17.2895 26.7123 16.936 27.0658 16.5 27.0658C16.064 27.0658 15.7105 26.7123 15.7105 26.2763L15.7105 21.5395C15.7105 21.1034 16.064 20.75 16.5 20.75C16.936 20.75 17.2895 21.1034 17.2895 21.5395L17.2895 26.2763Z",
    fill: "#D2D9E7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.25 11.75C53.25 13.8211 51.5711 15.5 49.5 15.5C47.4289 15.5 45.75 13.8211 45.75 11.75C45.75 9.67893 47.4289 8 49.5 8C51.5711 8 53.25 9.67893 53.25 11.75Z",
    fill: "url(#paint0_linear_13303_15314)",
    fillOpacity: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M141.75 23.375C141.75 26.0674 139.567 28.25 136.875 28.25C134.183 28.25 132 26.0674 132 23.375C132 20.6826 134.183 18.5 136.875 18.5C139.567 18.5 141.75 20.6826 141.75 23.375Z",
    fill: "url(#paint1_linear_13303_15314)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.625,
    cy: 123.875,
    r: 7.125,
    fill: "url(#paint2_linear_13303_15314)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101.352,
    y: 41.2969,
    width: 11.6303,
    height: 5.81516,
    transform: "rotate(42.0842 101.352 41.2969)",
    fill: "#62748A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100.936,
    y: 33.0833,
    width: 23.2607,
    height: 5.81517,
    rx: 2.90758,
    transform: "rotate(42.0842 100.936 33.0833)",
    fill: "#A9BBC9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 11.6303,
    height: 5.81517,
    transform: "matrix(-0.742161 0.670222 0.670222 0.742161 48.3457 41.2959)",
    fill: "#62748A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 23.2607,
    height: 5.81517,
    rx: 2.90758,
    transform: "matrix(-0.742161 0.670222 0.670222 0.742161 48.7637 33.0828)",
    fill: "#A9BBC9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.1138,
    cy: 76.6971,
    r: 38.7877,
    fill: "url(#paint3_linear_13303_15314)",
    stroke: "#A9BBC9",
    strokeWidth: 5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 74.5332,
    y: 44.7134,
    width: 2.32607,
    height: 5.81517,
    rx: 1.16304,
    fill: "#F17D83"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 74.5352,
    y: 102.865,
    width: 2.32607,
    height: 5.81517,
    rx: 1.16303,
    fill: "#A9BBC9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 107.68,
    y: 75.5337,
    width: 2.32606,
    height: 5.81517,
    rx: 1.16303,
    transform: "rotate(90 107.68 75.5337)",
    fill: "#A9BBC9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5273,
    y: 75.5337,
    width: 2.32606,
    height: 5.81517,
    rx: 1.16303,
    transform: "rotate(90 49.5273 75.5337)",
    fill: "#A9BBC9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 99.1348,
    y: 98.4902,
    width: 2.32607,
    height: 5.81517,
    rx: 1.16303,
    transform: "rotate(135 99.1348 98.4902)",
    fill: "#A9BBC9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 58.0156,
    y: 57.3708,
    width: 2.32607,
    height: 5.81517,
    rx: 1.16303,
    transform: "rotate(135 58.0156 57.3708)",
    fill: "#A9BBC9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9043,
    y: 100.135,
    width: 2.32607,
    height: 5.81517,
    rx: 1.16303,
    transform: "rotate(-135 53.9043 100.135)",
    fill: "#A9BBC9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0215,
    y: 59.0159,
    width: 2.32606,
    height: 5.81516,
    rx: 1.16303,
    transform: "rotate(-135 95.0215 59.0159)",
    fill: "#A9BBC9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 75.6973,
    y: 76.1152,
    width: 2.32607,
    height: 25.3419,
    rx: 1.16303,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 77.4062,
    y: 74.6797,
    width: 3.37044,
    height: 17.9768,
    rx: 1.68522,
    transform: "rotate(139.163 77.4062 74.6797)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.8592,
    cy: 76.1153,
    r: 4.65213,
    fill: "#D0DCE6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8847 92.9647C101.129 90.6784 104.38 90.6784 105.624 92.9647L118.099 115.885C119.299 118.091 117.72 120.79 115.229 120.79H90.2799C87.7888 120.79 86.2095 118.091 87.4101 115.885L99.8847 92.9647Z",
    fill: "url(#paint4_linear_13303_15314)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.817 99.1272C100.657 99.1272 99.1072 101.21 99.728 103.279L101.138 107.979L101.15 108.019C101.201 108.19 101.249 108.351 101.328 108.492C101.529 108.849 101.872 109.104 102.271 109.194C102.429 109.229 102.597 109.229 102.776 109.228L102.817 109.228L102.859 109.228C103.037 109.229 103.206 109.229 103.363 109.194C103.763 109.104 104.106 108.849 104.306 108.492C104.385 108.351 104.434 108.19 104.485 108.019L104.485 108.019L104.497 107.979L105.906 103.279C106.527 101.21 104.978 99.1272 102.817 99.1272Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.818 110.852C101.523 110.852 100.473 111.901 100.473 113.196C100.473 114.492 101.523 115.541 102.818 115.541C104.113 115.541 105.162 114.492 105.162 113.196C105.162 111.901 104.113 110.852 102.818 110.852Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13303_15314",
    x1: 45.75,
    y1: 9.15385,
    x2: 51.8077,
    y2: 14.6346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13303_15314",
    x1: 132,
    y1: 20,
    x2: 139.875,
    y2: 27.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13303_15314",
    x1: 68.625,
    y1: 116.75,
    x2: 68.625,
    y2: 131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE3ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13303_15314",
    x1: 33.8262,
    y1: 40.9144,
    x2: 116.402,
    y2: 122.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62748A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9BBC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13303_15314",
    x1: 87,
    y1: 93.2193,
    x2: 116.327,
    y2: 127.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeExpiredIcon);
export default __webpack_public_path__ + "static/media/time-expired-icon.f8ca99f949dcc6a81a5058c2803d7d6c.svg";
export { ForwardRef as ReactComponent };